export const MINS_TO_MS = 60000

export const WEB_SCREEN_WIDTH = 480

export const HOURS_TO_MS = 3600000

export const DAYS_TO_MS = 86400000

export const MAX_MESSAGE_LENGTH = 2000
